export default {
    menus: {
	    backend:{
		    basicManager:"人事中心",
		    businessManager:"业务管理",
		    cloudManager:"财务中心",
		    factoryManager:"工厂对接",
		    assetManager:"行政中心",
		    reportManager:"报表管理"
	    },
	    backendModule:{
		    basicSysModule:"系统",
		    basicHrModule:"人事",
		    basicSalaryModule:"薪资",
		    businessBasicModule:"基础",
            systemBasicModule:"系统服务",
		    businessWorkModule:"业务",
		    businessPlanningModule:"企划",
		    businessReportModule:"报表",
            operatorsModule:"运营商服务",
		    cloudReportModule:"报表",
		    cloudInputModule:"录单",
		    cloudSysModule:"系统",
		    factoryBasicModule:"基础",
		    businessFutureModule:"订货",
        businessProductModule:"商品中心",
		    businessLogisticsModule:"物流仓储",
		    businessImeModule:"串码",
		    businessCustomerModule:"渠道中心",
		    businessPerformanceModule:"考核激励",
		    businessAdvertisingModule:"终端企划",
		    businessAftersalesModule:"售后",
		    businessTrainingModule:"培训",
		    businessToolModule:"工厂对接",
		    basicDutyModule:"勤务服务",
		    basicEmployeeModule:"员工服务",
		    basicAccountModule:"账户服务",
		    basicRecruitModule:"招聘服务",
		    supportBasicModule:"业务基础",
		    assetAssetModule:"资产模块",
		    assetMessageModule:"消息中心",
            assetServiceModule: "后勤服务",
		    cloudModule:"金蝶管理",
		    reportModule:"报表管理",
            hrCooperationModule:"协同服务",
            businessDistributionModule: "分货",
	    },
    menuCategory:{
      hrCategory:"人事管理",
      sysCategory:"系统设置",
      saleCategory:"销售管理",
      apiCategory:"外部接口",
      menusCategory:"菜单",
      officeCategory:"组织机构",
      dictCategory:"字典",
      permissionCategory:"权限",
      fileCategory:"文件",
      dutyCategory:"勤务管理",
      workStreamCategory:"工作流",
      taskCenterCategory:"任务中心",
      accountAboutCategory:"员工相关",
      salaryCategory:"工资管理",
      productImeCategory:"货品串码",
      baseCategory:"基础资料",
      adCategory:"物料广告",
      customerCategory:"客服中心",
      afterSaleCategory:"售后管理",
      saleReportCategory:"销售报表",
      k3CloudCategory:"K3Cloud",
      b2bCategory:"移动商城",
      oppoDataCategory:"OPPO数据",
      dataManagerCategory:"数据管理",
      vivoDataCategory:"vivo数据",
      djDataCategory:"dj数据",
      taskPolicyCategory:"任务政策",
      commissionCategory:"提成基准",
      reportCategory:"报表中心",
      cloudBatchBillCategory:"批量录入",
      cloudReportCategory:"财务报表",
      cloudRetailReportCategory:"零售报表",
      cloudSysCategory:"系统设置",
      cloudBaseCategory:"基础管理",
      cloudCenterCategory:"个人中心",
      goodsOrderCategory:"订货管理",
    }
  }
}



// WEBPACK FOOTER //
// ./src/i18n/table_data_zh-CN.js